export const AiVariantSkeletons = {
  subjectSkeleton: [
    {
      maxWidth: 30,
      background:
        'linear-gradient(101.72deg, rgba(245, 245, 245, 0.1) -0.73%, rgba(157, 84, 219, 0.1) 53.72%, rgba(116, 153, 255, 0.1) 89.6%)',
    },
  ],

  emailHeading: [
    {
      maxWidth: 15,
      background:
        'linear-gradient(111.45deg, rgba(235, 76, 230, 0.1) -20.41%, rgba(157, 84, 219, 0.1) 48.87%, rgba(29, 78, 216, 0.1) 126.87%)',
    },
  ],

  firstParagraph: [
    {
      maxWidth: 90,
      background:
        'linear-gradient(108.24deg, rgba(219, 191, 242, 0.1) -5.01%, rgba(223, 223, 223, 0.1) 2.31%, rgba(157, 84, 219, 0.1) 66.84%, rgba(29, 78, 216, 0.1) 114.32%)',
    },
    {
      maxWidth: 90,
      background:
        'linear-gradient(104.15deg, rgba(235, 76, 230, 0.1) -11.35%, rgba(214, 214, 214, 0.1) 35.84%, rgba(157, 84, 219, 0.1) 62.15%, rgba(29, 78, 216, 0.1) 95.59%)',
    },
    {
      maxWidth: 65,
      background:
        'linear-gradient(108.24deg, rgba(219, 191, 242, 0.1) -5.01%, rgba(230, 230, 230, 0.1) 2.31%, rgba(157, 84, 219, 0.1) 66.84%, rgba(29, 78, 216, 0.1) 114.32%)',
    },
  ],

  secondParagraph: [
    {
      maxWidth: 90,
      background:
        'linear-gradient(108.24deg, rgba(219, 191, 242, 0.1) -5.01%, rgba(223, 223, 223, 0.1) 2.31%, rgba(157, 84, 219, 0.1) 66.84%, rgba(29, 78, 216, 0.1) 114.32%)',
    },
    {
      maxWidth: 90,
      background:
        'linear-gradient(103.07deg, rgba(235, 76, 230, 0.1) -3.62%, rgba(214, 214, 214, 0.1) 24.61%, rgba(157, 84, 219, 0.1) 68.8%, rgba(29, 78, 216, 0.1) 88.91%)',
    },
    {
      maxWidth: 65,
      background:
        'linear-gradient(108.24deg, rgba(219, 191, 242, 0.1) -5.01%, rgba(230, 230, 230, 0.1) 2.31%, rgba(157, 84, 219, 0.1) 66.84%, rgba(29, 78, 216, 0.1) 114.32%)',
    },
  ],

  thirdParagraph: [
    {
      maxWidth: 90,
      background:
        'linear-gradient(108.24deg, rgba(219, 191, 242, 0.1) -5.01%, rgba(223, 223, 223, 0.1) 2.31%, rgba(157, 84, 219, 0.1) 66.84%, rgba(29, 78, 216, 0.1) 114.32%)',
    },
    {
      maxWidth: 90,
      background:
        'linear-gradient(105.75deg, rgba(235, 76, 230, 0.1) -12.13%, rgba(214, 214, 214, 0.1) 40.82%, rgba(157, 84, 219, 0.1) 70.34%, rgba(29, 78, 216, 0.1) 107.86%)',
    },
    {
      maxWidth: 65,
      background:
        'linear-gradient(108.24deg, rgba(219, 191, 242, 0.1) -5.01%, rgba(230, 230, 230, 0.1) 2.31%, rgba(157, 84, 219, 0.1) 66.84%, rgba(29, 78, 216, 0.1) 114.32%)',
    },
  ],
};
